import { Injectable } from '@angular/core';

import {
  ANALYTICS_EVENTS,
  USER_LOGGED_IN_STATUS
} from '../../../constants/utils';
import { CustomEventSuccessAnalytics } from '../../../models/utils';
import { AdobeDataLayerService } from './adobe-data-layer';

@Injectable({
  providedIn: 'root'
})
export class AdobeDataLayerServiceExtended extends AdobeDataLayerService {
  previousPageName = '';
  previousUrl = '';

  checKSysEnv(): string {
    const isMobile = window.innerWidth < 768;
    return isMobile ? 'mobile' : 'desktop';
  }

  getValue(length: number, index: number, parts: string[]): string {
    return parts && parts.length > length ? parts[parts.length - index] : '';
  }

  checkHomePage(
    section: string,
    sub_section: string
  ): { section: string; sub_section: string; pageName: string } {
    let pageName = '';
    if ((!section || section === '') && sub_section === '') {
      section = 'home';
      sub_section = 'no-subsection';
      pageName = section;
      return { section, sub_section, pageName };
    }
    pageName = this.getPageName(section, sub_section);
    return { section, sub_section, pageName };
  }

  getLegacyPageName(section: string): string {
    return section === 'home' ? 'Home Page' : window.document.title;
  }

  getPageName(section: string, sub_section: string): string {
    return sub_section && sub_section !== '' ? sub_section : section;
  }

  getLastPageTitle(): void {
    const currentUrl = window.location.href;
    const storedPrevious = localStorage.getItem('previous_page_url');
    if (storedPrevious && storedPrevious !== currentUrl) {
      this.previousUrl = storedPrevious;
      const pathName = new URL(storedPrevious).pathname;
      const segments = pathName.split('/');
      // Get the last segment, which should be the file name
      this.previousPageName = segments[segments.length - 1];
    }
    localStorage.setItem('previous_page_url', currentUrl);
  }

  setLoginAccountRecoverySuccess(viewPage: string): void {
    const data: CustomEventSuccessAnalytics = {
      event: ANALYTICS_EVENTS.CUSTOM,
      event_detail: viewPage,
      user: {
        attributes: {
          is_logged_in: USER_LOGGED_IN_STATUS.UNAUTHENTICATED,
          login_state: USER_LOGGED_IN_STATUS.COLD
        }
      }
    };
    this.analytics.setSuccessAnalytics(data);
  }
}
